import { render, staticRenderFns } from "./RelatorioSolicitacoesItens.vue?vue&type=template&id=2417b546"
import script from "./RelatorioSolicitacoesItens.vue?vue&type=script&lang=js"
export * from "./RelatorioSolicitacoesItens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports